import { IResult } from '../../models/result-models';
import { ITempMessage } from '../../models/temp-message';
import {
    LOAD_TEMP_MESSAGES_ERROR,
    LOAD_TEMP_MESSAGES_SUCCESS,
} from './temp-message-actions';

interface LoadTempMessagesSuccessAction {
    type: 'LOAD_TEMP_MESSAGES_SUCCESS';
    payload: IResult<ITempMessage[]>;
}

interface LoadTempMessagesErrorAction {
    type: 'LOAD_TEMP_MESSAGES_ERROR';
    payload: IResult<ITempMessage[]>;
}

type KnownAction = LoadTempMessagesSuccessAction | LoadTempMessagesErrorAction;

export const tempMessageReducer = (
    state: IResult<ITempMessage[]> | null = null,
    action: KnownAction
) => {
    switch (action.type) {
        case LOAD_TEMP_MESSAGES_SUCCESS:
            return action.payload;
        case LOAD_TEMP_MESSAGES_ERROR: {
            const result: IResult<ITempMessage[]> = {
                ...action.payload,
                data: state ? state.data : null,
            };
            return result;
        }
        default:
            return state;
    }
};
